export default  {
    component: 'ups_param',
    name: 'ups_param',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Role',
            param: 'role',
            type: 'text',
            description: `We need to add 3 types of roles:
            - **user** 
            - **admin** 
            - **super-admin**`
          },
          {
            name: 'Module',
            param: 'module',
            type: 'text',
            description: `Their are 2 options for module:
            - **other-sensor**
            - **analytics**
            We need to add module for each roles`
          },
          {
            name: 'Parameters',
            param: 'parameters',
            type: 'text',
            description: `Option for parameters are displayed as follows::
            - **other-sensor** [Parameter Options : ac_output_voltage,frequency,battery_voltage,current_load,ups_healthy,ups_bypass,on_battery,battery_current,rectifier_voltage,ac_input_current,output_frequency]
            - **analytics** [Parameter Options : ups_healthy, ups_bypass, on_battery, battery_voltage, battery_current, rectifier_voltage, ac_input_voltage, ac_input_current, frequency, ac_output_voltage, ac_output_current, output_frequency ]`
          }
    ]
  }
